"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:6.5.3'] && _();
}
catch (e) { }
